
import React, { useState, useRef, useEffect } from 'react';
import styles from './notification.module.css';
import { axiosInstance } from '../../../lib/axiosInstance';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider';
import { useAuth } from '../../global_state_components/AuthProvider';
import { useNavigate } from 'react-router-dom';


function Notification(){
  const {contact, setContact} = useGlobalState();
  const {isAuthenticated, setIsAuthenticated} = useAuth();

  const [privateSessionRequests, setPrivateSessionRequests] = useState('');
  const [sentPrivateBookRequests, setSentPrivateBookRequests] = useState('');
  const [receivedPrivateBookRequests, setReceivedPrivateBookRequests] = useState('');

  useEffect(()=>{
    async function getNotification(){
      try {
        const response = await axiosInstance.get('/sessions/requests/sent');
        setSentPrivateBookRequests(response.data);

        const res = await axiosInstance.get('/sessions/requests/received');
        setReceivedPrivateBookRequests(res.data);

      } catch (error) {
        //console.log("Error in handleDirectAndRequestBook function : "+error);
        if (error.response) {
          // Server responded with a status other than 200 range
          console.log("Error Data: ", error.response.data);
          console.log("Error Status: ", error.response.status);
          console.log("Error Headers: ", error.response.headers);
        } else if (error.request) {
          // Request was made but no response was received
          console.log("Error Request: ", error.request);
        } else {
          // Something else happened
          console.log("Error Message: ", error.message);
        }
      }
    }
    getNotification();
  },[]);

  useEffect(()=>{
    //console.log("All received private book requests : "+JSON.stringify(receivedPrivateBookRequests, null, 2))

  },[receivedPrivateBookRequests]);

  return(
    <div className={styles.main_div}>

      <div>
        <h3>Sent requests</h3>
        <p>All sent private book requests : {JSON.stringify(sentPrivateBookRequests, null, 2)}</p>
      </div>


      <div>
        <h3>Received requests</h3>
        <p>All received private book requests : {JSON.stringify(receivedPrivateBookRequests, null, 2)}</p>
      </div>
      

    </div>

  )

}

export default Notification;